import QuickLinks from "@urp/quick-links";
import UpcomingRacesLegacy from "@fdr/upcoming-races";
import { TalentPickList } from "@urp/talent-picks";
import TopRacesLegacy from "@fdr/top-races";
import { TopRaces } from "@urp/popular-races";
import VideoPlaylist from "@fdr/video-builder";
import TopTracks from "@urp/top-tracks";
import TopPools from "@urp/top-pools";
import mediator from "@tvg/mediator";
import { TipsAndPicks } from "@urp/tips-picks";
import PromosWidget from "@urp/promos-widget";
import PreviousWinners from "@urp/previous-winners";
import UpcomingRaces from "@urp/upcoming-races";
import { triggerAmplitudeEvent } from "@urp/talent-picks/src/utils/amplitude";
import { EVENTS } from "@tvg/amplitude/modules/talentPicks/constants";
import FeaturedSection from "../components/featuredSection";

import { ComponentMap, ComponentType, ComponentMapOptions } from "./types";
import DummyComponent from "./dummyComponent";

const componentMap = (options?: ComponentMapOptions): ComponentMap => ({
  QUICK_LINKS: {
    type: ComponentType.FIXED,
    props: ["quickLinksExpanded", "device", "shouldUpdate"],
    component: QuickLinks,
    withoutHeaderSpace: true
  },
  TOP_RACES: {
    type: ComponentType.FULL,
    props: ["device", "shouldUpdate", "message"],
    context: ["rdaClient"],
    component: options?.topRacesDS?.enabled ? TopRaces : TopRacesLegacy
  },
  UPCOMING_RACES: {
    type: ComponentType.FULL,
    props: ["device", "shouldUpdate"],
    context: ["rdaClient"],
    component: options?.upcomingRaces.enabled
      ? UpcomingRaces
      : UpcomingRacesLegacy
  },
  TOP_TRACKS: {
    type: ComponentType.LARGE,
    props: ["device", "shouldUpdate"],
    component: TopTracks,
    withoutHeaderSpace: true
  },
  PROMO_WIDGET: {
    type: ComponentType.SMALL,
    props: ["shouldUpdate", "device"],
    component: PromosWidget
  },
  TOP_POOLS: {
    type: ComponentType.SMALL,
    props: ["shouldUpdate", "device"],
    component: TopPools
  },
  TALENT_PICKS: {
    type: ComponentType.FULL,
    props: ["device", "shouldUpdate"],
    component: TalentPickList,
    headerLink: {
      label: "See all",
      to: "/handicapping/talent-picks",
      onClick: () => triggerAmplitudeEvent(EVENTS.CTA_CLICKED)
    }
  },
  SEO_FOOTER: {
    type: ComponentType.LARGE,
    component: DummyComponent,
    isStandalone: true
  },
  PROMO_BANNER_TOP: {
    type: ComponentType.TOP,
    component: DummyComponent,
    isStandalone: true
  },
  PROMO_BANNER_BOTTOM: {
    type: ComponentType.BOTTOM,
    component: DummyComponent,
    isStandalone: true
  },
  HOME_PLAYLIST: {
    type: ComponentType.SMALL,
    component: options?.tipsAndPicks.enabled ? TipsAndPicks : VideoPlaylist,
    withoutHeaderSpace: true
  },
  HORSE_RACING_101: {
    type: ComponentType.FULL,
    component: FeaturedSection,
    withoutHeaderSpace: true
  },
  PREVIOUS_WINNERS: {
    type: ComponentType.FULL,
    component: PreviousWinners,
    props: ["title", "device"],
    // TODO: Change this to a dispatch to the redux store
    headerLink: {
      label: "See all",
      onClick: () =>
        mediator.base.dispatch({ type: "PREVIOUS_WINNERS:SEE_ALL" })
    }
  },
  DEFAULT: {
    type: ComponentType.DEFAULT,
    component: DummyComponent,
    isStandalone: true
  }
});

export default componentMap;
